import DashboardCalendar from "../../components/DashboardCalendar"
import InstallmentsCard from "../../components/InstallmentsCard"
import Card from "../../components/cards/Card"
import OnlineCard from "../../components/cards/OnlineCard"
import OrdersCard from '../../components/cards/OrdersCard'
import styles from "../Dashboard.module.css"
import mainStyles from "./DashboardMain.module.css"

const DashboardMain = ({ user }) => {
    return (
        <div className={`${styles.section} ${mainStyles.dashboard}`}>
            <div className={styles.sectionInner}>
                <header className={mainStyles.header}>
                    <div><p className={mainStyles.eyebrow}>Panoramica</p><h1>Benvenuto, {user.name}</h1><p>Lezioni, attività e pagamenti in un unico posto.</p></div>
                </header>
                <div className={mainStyles.overview}>
                    <Card appearance="modern" title="Calendario lezioni" style={{ flexDirection: 'column' }}>
                        <DashboardCalendar />
                    </Card>
                    <OrdersCard modern />
                </div>
            </div>
            <div className={styles.sectionInner}>
                <OnlineCard modern />
                <InstallmentsCard modern />
            </div>
        </div>
    )
}

export default DashboardMain
